export default __webpack_public_path__ + "static/media/CELO.4fb27e3a.svg";